import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSessionId } from "../../../../../../utils/tokenHandlers";
import { getKybInfo } from "../../apis/getKybInfo";

export const getKybInfoAction = createAsyncThunk(
  "getKybInfoAction",
  async (digioId: string) => {
    return getKybInfo(digioId, getSessionId()).then((response: any) => {
      return response.data;
    });
  }
);
